class ErrorCodes {
  // JSON-RPC стандартные ошибки
  static readonly PARSE_ERROR = -32700;
  static readonly INVALID_REQUEST = -32600;
  static readonly METHOD_NOT_FOUND = -32601;
  static readonly INVALID_PARAMS = -32602;
  static readonly INTERNAL_ERROR = -32603;

  // Application errors
  static readonly UNKNOWN_EXCEPTION = -32500;
  static readonly TYPE_ERROR = -32501;
  static readonly DATABASE_EXCEPTION = -32502;
  static readonly AUTH_REQUIRED = -32503;
  static readonly TRANSACTION_EXCEPTION = -32504;
  // Application notices
  static readonly UNIQUENESS_VIOLATION = -32505;
  static readonly OBJECT_NOT_FOUND = -32510;
  static readonly OBJECT_VERSION_MISMATCH = -32506;
  static readonly ACCESS_VIOLATION = -32508;
  static readonly LINKED_ENTITY_DETECTED = -32509;
  static readonly VALIDATION_ERROR = -32511;

  static readonly TIMEOUT_ERROR = 4001;
}

export default ErrorCodes;